import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { RenderControl } from 'components/RenderHelpers';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createLoadingSelector, createErrorMessageSelector } from 'selectors';
import PropTypes from 'prop-types';
import { PRT_DETAIL_ACTIONS } from 'actions/protocols/protocoldetail';
import { getTableColumns, GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';

const loadingSelector = createLoadingSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST
]);
const errorSelector = createErrorMessageSelector([
  PRT_DETAIL_ACTIONS.GET_PROT_STATUS_HIST
]);


const ChangeHistoryColumns = [
  ['effectiveDate', 'string', 'Effective Date', 'left', true],
  ['action', 'string', 'Action', 'left', true],
  ['actionDate', 'string', 'Action Date', 'left', true],
  ['user', 'string', 'By', 'left', true],
  ['userCtepId', 'string', 'User CTEP ID', 'left', true],
  ['from', 'string', 'From', 'left', true],
  ['to', 'string', 'To', 'left', true],
  ['value', 'string', 'Value', 'left', true]
];


const ChangeHistory = ({ data }) => (
  <GridTable
    tag={`${TE.ID}statuschangehistory${TE.TABLE}`}
    title="Protocol Status History"
    exportTitle={`Protocol Status History-${useGetPathProtocol()}-Protocol Details`}
    user={GetUserFullName()}
    columns={getTableColumns(ChangeHistoryColumns)}
    rows={data}
    filterable
    sortable
    enableToolbar
    recordPerPage={10}
    toPdf={false}
  />
);

ChangeHistory.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object])
};

ChangeHistory.defaultProps = {
  data: null
};

export { ChangeHistory };

const prtStatusChangeHistory = props => {
  const { prtStatusChangeHist, isLoading, iserror } = props;
  return (
    <RenderControl
      isLoading={isLoading}
      iserror={iserror}
      compName="Protocol Status Change History"
      permission
    >
      <ChangeHistory data={prtStatusChangeHist} />
    </RenderControl>
  );
};

prtStatusChangeHistory.propTypes = {
  isLoading: PropTypes.bool,
  iserror: PropTypes.bool,
  prtStatusChangeHist: PropTypes.oneOfType([PropTypes.object])
};

prtStatusChangeHistory.defaultProps = {
  isLoading: false,
  iserror: false,
  prtStatusChangeHist: null
};

const withConnectState = connect((state, ownProps) => ({
  prtStatusChangeHist: state.prtDetails.prtStatusChangeHist,
  isLoading: loadingSelector(state),
  iserror: errorSelector(state)
}));

const StatusChangeHistory = compose(withConnectState)(prtStatusChangeHistory);
export default StatusChangeHistory;
